import { z } from 'zod';
import { OnboardingFormFields } from '@Types/index.ts';

export const phoneFormScheme = z.object({
  [OnboardingFormFields.PHONE_NUMBER]: z.string().trim(),
  [OnboardingFormFields.PHONE_NUMBER_VALIDATION_STATUS]: z.boolean().refine((value) => value),
});
